import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    ProductType,
} from 'app/enums/label.enums'

import {
    ContainerStatusBreakdownType,
} from '../ScenarioEditor.types'

const getColumns = (
    l:(l:string) => string,
): RichTableColumns<keyof ContainerStatusBreakdownType>[] => {
    return [
        {
            id: 'productType',
            headerProps: {
                children: l('Fee.productType'),
            },
            mapCellProps: 'productType',
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
        },
        {
            id: 'preconditioning',
            headerProps: {
                children: l('ContainerStatusBreakdown.preconditioning'),
            },
            mapCellProps: 'preconditioning',
        },
        {
            id: 'checkPreconditioning',
            headerProps: {
                children: l('ContainerStatusBreakdown.checkPreconditioning'),
            },
            mapCellProps: 'checkPreconditioning',
        },
        {
            id: 'preconditioned',
            headerProps: {
                children: l('ContainerStatusBreakdown.preconditioned'),
            },
            mapCellProps: 'preconditioned',
        },
        {
            id: 'qcPassed',
            headerProps: {
                children: l('ContainerStatusBreakdown.qcPassed'),
            },
            mapCellProps: 'qcPassed',
        },
        {
            id: 'qcPassedAutomated',
            headerProps: {
                children: l('ContainerStatusBreakdown.qcPassedAutomated'),
            },
            mapCellProps: 'qcPassedAutomated',
        },
        {
            id: 'toBeMaintained',
            headerProps: {
                children: l('ContainerStatusBreakdown.toBeMaintained'),
            },
            mapCellProps: 'toBeMaintained',
        },
    ]
}

export default getColumns
